import React, { useEffect } from 'react';
import '../../css/Gallery.css'
import Item from '../Item';
import GalleryCatagory from './GalleryCatagory';
import Carousel from 'react-elastic-carousel'

function Gallery() {
  useEffect(() => {
    document.documentElement.scrollTop = 0
  }, []);
  let galleryCatagory = ["Team and office", "Prospectus", "Events", "Carrier", "Achievements", "Videos", "Others"]
  let catagoryPics = []
  let PicsCount = [18, 5, 21, 1, 20, 11, 2]

  for (let i = 0; i < PicsCount.length; i++) {
    let pics=[]
    for (let j = 1; j < PicsCount[i] +1; j++) {
      if (i===0) {
        pics.push(`t${j}.png`)
      }
      else if (i===1) {
        pics.push(`p${j}.png`)
      }
      else if (i===2) {
        pics.push(`e${j}.png`)
      }
      else if (i===3) {
        pics.push(`c${j}.png`)
      }
      else if (i===4) {
        pics.push(`a${j}.png`)
      }
      else if (i===5) {
        pics.push(`e${j}.png`)
      }
      else if (i===6) {
        pics.push(`o${j}.png`)
      }
    }
    catagoryPics.push(pics)
  }
  console.log(catagoryPics)
  function renderPagination({ pages, activePage, onClick }) {
    return (
      <div className="d-flex justify-content-evenly align-items-end flex-wrap catagory-nav">
        {pages.map((catagory, index) => {
          const isActiveCatagory = activePage === catagory
          return (
            <div
              key={catagory}
              onClick={() =>
                onClick(catagory)
              } style={{ color: `${isActiveCatagory ? "#FF7043" : "grey"}`, cursor: "pointer", transition: ".5s", borderBottom: `${isActiveCatagory ? "2px solid #FF7043" : ""}` }}
              active={isActiveCatagory} className='h5 px-4'>{galleryCatagory[index]} </div>
          )
        })}
      </div>
    )
  }

  return (
    <>
      <div className="d-flex justify-content-center align-items-end gallery-div" >

        <h1 className="py-3 text-center text-white letter-dis-2 ">Gallery</h1>
      </div>

      <Carousel
        itemsToShow={1}
        itemsToScroll={1}
        easing="cubic-bezier(0,1.2,.76,.81)"
        tiltEasing="cubic-bezier(0.110, 1, 1.000, 0.210)"
        transitionMs={800}
        className={`${window.innerWidth > 750 && "container"}  position-relative `}
        
        // renderArrow={myArrow}
        renderPagination={renderPagination}
      >
        {galleryCatagory.map((catagory, index) => {
          return <Item key={catagory} className="pt-5 mt-5">
            <GalleryCatagory title={catagory} pics={catagoryPics[index]} />
          </Item>
        })}
      </Carousel>

    </>
  )
}

export default Gallery;
